export default {
    login: 'Login',
    logout: 'Logout',
    register: 'Registrado',
    upload: 'Upload',
    name: 'Nombre',
    email: 'Email',
    password: 'Contraseña',
    passwordConfirmation: 'contraseña (verificación)',
    isCommunityManager: 'Community Manager',
    dashboard: 'Tablero',
    offerLists: 'Lista de ofertas',
    schedule: 'Itinerario',
    accountEdit: 'Editando cuenta',
    edit: 'Editar',
    detail: 'Detalle',
    fullname: '{{lastname}} {{firstname}}',
    quantity: 'Cantidad',
    quantityWithWeight: 'Cantidad (Peso)',
    confirmTitle: 'Confirmacion',
    orderInformation: 'Información de reserva',
    orderPrices: 'Historial de cambio de precios',
    invoices: 'Facturas',
    contact: 'Contacto',
    when: 'Cuándo',
    add_to_google_calendar: 'Añadir a Google Calendar',
    pages: {
        dashboard: {
            unpaidInvoices: {
                title: 'Unpaid invoices (10 unpaid invoices are displayed order by expired date)',
                totalUnpaidAmountAll: 'Unpaid invoices(all)',
                totalUnpaidAmountExpired: 'Unpaid invoices(expired)',
                more: 'view all',
            },
            typicaStockItemDelaySummaryPanel: {
                title: 'TYPICA selection residency status',
                chartTitleFromImported: 'imported to purchased',
                chartTitleFromPurchased: 'purchased to delivered',
                within1month: 'within 1month',
                within2month: 'within 2months',
                within3month: 'within 3months',
                within4month: 'within 4months',
                within5month: 'within 5months',
                over5month: 'over 5month',
                unitLabel: 'Weight(Kg)',
            },
            remainingWarehouseItems: {
                title: 'Pending status of pre-orders (Lump-sum payment after the initial delivery or Pay per delivery)',
                subTitles: {
                    byPeriod: 'By Period',
                    byCommunityManager: 'By Community manager',
                    byOffice: 'By Office',
                },
                more: 'view all',
                unitLabel: 'Weight(Kg)',
            },
        },
        offerUpload: {
            title: 'Actualizando CSV',
            producer: 'Producers',
            download: 'Existe el tablero CVS',
            sampleDeliveryDateMemo: 'Debe ser 14 días antes de la fecha de inicio deseada de la oferta ',
            uploadMemo: 'Una vez completada la carga, la persona a cargo se comunicará con usted en una fecha posterior',
            suggestToCreateBankAccountText: "Debe especificar una cuenta bancaria para recibir los ingresos de las ventas.\nSe requiere al momento de emitir un Contrato de Venta( Sales Contract), por lo que se recomienda registrarse al momento de cargar la lista de ofertas.",
        },
        offerList: {
            title: 'Lista de ofertas de {{ country }}/{{ name }}',
            createInvoices: 'Crear factura',
            createInvoicesExplanation: "Las facturas se emitir\u00E1n en una suma global para aquellos cuyo plazo de pago sea \"1. Pago \u00FAnico seg\u00FAn lo desee el productor\" en la informaci\u00F3n de reserva registrada.\nSin embargo, no se crear\u00E1 una nueva factura para las reservas para las que ya se ha emitido una factura.\nLa URL de la factura creada se enviar\u00E1 por correo electr\u00F3nico a cada tostador.",
            sampleOrderStock: {
                quantity: 'Clasificación de inventario de muestra',
                lotVisibleLabel: 'Show/Hide Lot',
                show: 'Show',
                hide: 'Hide',
            },
            publishedCountriesTableTitle: 'Paises en venta',
            basicInformations: 'Información básica',
            publishedCountriesTable: 'Paises en venta',
            transportToWarehouseTable: 'Información de transporte de la unidad de almacén',
            officeDetailTable: 'Office Information',
            offersTable: 'Offers',
            contracts: 'Contracts',
            sampleOrderPeriod: 'Recepción de muestra',
            orderPeriod: 'Recepción de reserva',
            paymentPeriod: 'Tiempo de pago',
            estimatedDeliveryPeriod: 'Entrega estimada',
            paymentAfterDelivery: 'Pago posterior a la entrega',
            paymentPeriods: {
                reserved: 'On order confirmation',
                exported: 'On departure from origin',
                imported: 'On arrival at destination',
                delivered: 'On delivery',
            },
            installmentPaymentAfterImport: 'Múltiples plazos tras la llegada al almacén',
            installmentPayment: 'plazos',
            estimatedPaymentDateFormat: '{{date}} {{month}} {{year}}',
            installmentPaymentsHelp: {
                title: 'Sobre pago diferido',
                body: "Al momento de reservar y elegir el \"pago diferido\" es posible el pago lueo de ser entregado.\nEn la primera vez que se entrega el producto, se puede elegir \"todo el costo diferido\" o, \"pago cada vez que es entregado\" sobre el producto almacenado en el deposito.",
            },
            FreeOnBoardHelp: {
                title: 'Que es FOB',
                body: "El precio de los granos de caf\u00E9 verde cuando llegan al puerto del pa\u00EDs de origen.\nEl flete mar\u00EDtimo y las tarifas de importaci\u00F3n no est\u00E1n incluidos.",
            },
            estimatedDeliveryPeriodFormat: '{{monthPart}} {{month}} {{year}}',
            okagesamaNoMori: 'OKAGESAMA',
            okagesamaNoMoriContributors: 'OKAGESAMA Contributors',
            okagesamaNoMoriTotalPrices: 'OKAGESAMA Total prices',
            okagesamaNoMoriStatuses: {
                title: 'OKAGESAMA Statuses',
                joined: 'Joined',
                paid: 'Joined(Paid)',
            },
        },
        editProfile: {
            title: 'Editar perfil',
            subTitle: 'Información del cliente',
            questionnairesForRoaster: 'Encuesta relacionada al tostador',
            questionnairesForRoasterMemo: '* La siguiente informacion se puede cambiar luego',
            cannotChangeCountry: '* Tenga en cuenta que una vez registrado, el país de afiliación no se puede cambiar',
        },
        editAccount: {
            title: 'Editar la información de la cuenta',
            currentEmail: 'Email actual',
            warning: "Despu\u00E9s de cambiar su direcci\u00F3n de correo electr\u00F3nico, se cerrar\u00E1 la sesi\u00F3n una vez.\nSe enviar\u00E1 un correo electr\u00F3nico de confirmaci\u00F3n a su nueva direcci\u00F3n de correo electr\u00F3nico. Haga clic en el enlace proporcionado para completar la reflexi\u00F3n.\nLuego puede iniciar sesi\u00F3n con su nueva direcci\u00F3n de correo electr\u00F3nico.",
        },
        exchangeRates: {
            title: 'Ajuste del tipo de cambio',
            exchangeRateColumnTitle: 'USD/{{ currency }} conversión',
        },
        roasterOfferLists: {
            sampleRequest: 'Solicitud de muestra',
            order: 'Reserva',
            inactive: 'expirado',
        },
        roasterOrder: {
            title: 'Reserva de {{listName}}',
            explanationSelectOffers: '・Verifique la cantidad de existencias en la lista a continuación y seleccione la cantidad reservada.',
            explanationAuctionWithFobPriceUsdPerLb: '* Los resultados de la subasta se basan en. (1kg=2.20462lb)',
            explanationStockMightChange: '* Tenga en cuenta que el inventario puede agotarse mientras la pantalla está abierta.',
            order: 'Reserva',
            orderAmount: 'Reserva',
            totalFee: 'Importe total: {{ fee }} (impuestos incluidos)',
            totalBags: 'Número total de maletas: {{ amount }} sacos',
            totalOrderedBags: 'Total de sacos solicitados: {{ amount }}',
            totalWeight: 'Peso total: {{ weight }} kg',
            totalOrderedWeight: 'Peso pedido: {{ weight }} kg',
            totalOneTimeUpfrontOrderedBags: 'Total de sacos solicitados con descuento por pago anticipado: {{ amount }}',
            typicaHandlingFee: 'Tarifa de TYPICA: {{ percentage }}%',
            typicaHandlingFeeExplanationByBagCount: 'Menos de 5 sacos {{ lessThan5Bags }} / 5 sacos o más {{ moreThan5Bags }} / 10 sacos o más {{ moreThan10Bags }} / 50 sacos o más {{ moreThan50Bags }}',
            typicaHandlingFeeExplanationByWeight: 'Menos de 300 kg: {{ lessThan300Kg }} / 300 kg o más: {{ moreThan300Kg }} / 600 kg o más: {{ moreThan600Kg }} / 3,000 kg o más: {{ moreThan3000Kg }}',
            details: 'Detalles',
            paymentAndDelivery: 'Método de pago / dirección de entrega',
            paymentMethodExplanation: "* Los l\u00EDmites de uso de la tarjeta de cr\u00E9dito y las condiciones de pago a plazos var\u00EDan seg\u00FAn el usuario. Comun\u00EDquese con la compa\u00F1\u00EDa de la tarjeta para obtener m\u00E1s detalles.\n        * Si el monto facturado en una sola vez supera los 8 d\u00EDgitos, tenga en cuenta que se lo tratara como una transferencia bancaria.",
            endOfMonth: 'Hasta finales de',
            oneTimeUpfrontExplanations: '- El pago debe realizarse el {{ paymentDate }}. Para más información, consulta la factura emitida una vez cerrada la oferta.',
            afterImportPaymentExplanations: "-Pago Neto 14 desde la llegada al almac\u00E9n (estimaci\u00F3n: {{ deliveryPeriod }}).\n      - Producto disponible para su env\u00EDo una vez recibido el pago.",
            fewTimesPaymentAfterImportExplanations: "- Primer pago 14 neto a partir de la llegada al almac\u00E9n (estimaci\u00F3n: {{ deliveryPeriod }}).\n      - Producto disponible para la venta tras la recepci\u00F3n del primer pago.\n      - Los pagos posteriores vencen al final de cada mes siguiente al mes de llegada al almac\u00E9n. Para m\u00E1s detalles, consulte la factura emitida a principios de cada mes.",
            paymentTimingExplanation: '* Las tarifas varían según el momento del pago. Para obtener más información, consulte el simulador de precios en la parte inferior de la pantalla.',
            oneTimeUpfrontRateConstraintByBagAmount: ' (limitado a reservas de 2 o más sacos)',
            oneTimeUpfrontRateConstraintByWeight: ' (Sólo para reservas de 120 kg o más)',
            deliveryMethodExplanation: "* Se cobrar\u00E1 una tasa de almacenamiento mensual de {{unitPrice}} por kg a partir del primer d\u00EDa del segundo mes siguiente a la fecha de entrada en nuestro almac\u00E9n.",
            oneTimeUpfrontRateByBagAmount: '({{ percentage }} de descuento * limitado a reservas de 2 o más sacos)',
            oneTimeUpfrontRateByWeight: ' | -{{ percentage }} Descuentos',
            paymentTimingNegativeRate: ' | -{{ percentage }} Descuentos',
            paymentTimingPositiveRate: ' | Tasa de financiación {{ positive }}{{ percentage }}',
            addressExplanation: '* Tenga cuidado de no introducir el nombre del apartamento, el número de habitación, etc.',
            emailExplanation: '* Tenga cuidado de no ingresar la dirección de correo electrónico incorrecta.',
            deliveryTimeEtcExplanation: '* Tenga en cuenta que es posible que no podamos responder a su solicitud, como especificar el tiempo de entrega.',
            sample: 'Muestras',
            sampleOrder: 'Solicitud de muestra',
            sampleOrdered: 'Reservado',
            outOfSamples: 'Out of samples',
            bidSubmitted: 'Puja realizada',
            sampleOrderableCount: 'Numero de lot que se pueden solicitar muestras',
            inputAddress: 'Para ingreso de direccion',
            simulateAndInputAddress: 'para detalle de precios e ingreso de direccion',
            simulation: 'Simulacion de precios',
            sampleOrderCaption: 'Reservar la muestra de los siguientes LOT',
            comment: 'Comentario',
            commentHelp: '* Los comentarios se compartiran a los productores y otros tostadores',
            translation: '* Los comentarios pueden traducirse al inglés, español, japonés, chino y coreano.',
            postComment: 'Comentar',
            updateComment: 'Actualizar comentario',
            deleteComment: 'Eliminar comentario',
            noComments: 'No hay comentario',
            cuppingScoreHelpText: 'Ingrese el puntaje evaluado en el formulario de cata de SCA',
            more: 'Ver mas',
            ordered: 'Reservado',
            addInvoice: 'Crear factura',
            preOrderExplanation: 'El período de la reserva está programado para  {{startedAt}} - {{endedAt}}.',
            countdownToOrder: '{{countdown}} para comenzar a reservar',
            confirmationOfBuyPartial: 'Lote: si {{lotNumber}} es menor que la cantidad de la oferta no gana la puja',
            auctionBadgeExplanation: "Este lote est\u00E1 a la venta en una subasta a ciegas.\nIngrese el precio de compra y la cantidad deseada.\nCualquier monto por encima del precio inicial se pagar\u00E1 al productor como un bono de subasta.\nEl resultado de la subasta se notificar\u00E1 por correo electr\u00F3nico en una fecha posterior.\nEl n\u00FAmero en la insignia es el n\u00FAmero actual de compras deseadas.",
            okagesamaNoMoriPrice: '* Tarifa de participación {{ priceUsd }} (aprox. {{ price }})',
            okagesamaNoMoriPriceText: '(La tarifa puede variar según el tipo de cambio.)',
            sampleStats: 'vistos por tostadores',
            preorderStats: 'comprados por tostadores',
        },
        ordersPage: {
            title: 'Lista de reservas',
            detailsTitle: 'Pre-orders details',
        },
        sampleOrdersPage: {
            title: 'Lista de solicitudes de muestra',
        },
        register: {
            accept: 'Aceptar terminos',
        },
        orderedOfferLists: {
            title: 'Lista de ofertas reservadas',
        },
        sampleOrders: {
            title: 'Lista de solicitudes de muestra',
            import: 'Importación de solicitud de muestra',
        },
        sampleOrderedOfferLists: {
            title: 'Lista de ofertas de las muestras solicitadas',
        },
        orderDetail: {
            orderItemsTableTitle: 'lista de lotes de reserva',
            bidsTableTitle: 'Lista de lotes de ofertas',
            changeStatus: 'Change status',
            preOrderRequestCreateOrEdit: 'Crear/editar solicitud',
        },
        sampleOrderDetail: {
            requestedLotNumbers: 'Numero de lot que se solicitaron las muestras',
        },
        invoice: {
            title: 'Factura de reserva {{ orderIds }}',
            billingTo: 'Facturacion',
            billingAddress: 'Direccion de facturacion',
            transparencyInformation: {
                farm: 'Productor',
                farmExplanation: 'Consulte <1>aquí</1> para obtener información sobre el productor.',
                mill: 'Planta de trillado',
                millExplanation: 'Las cerezas de café y el cafe en pergamino comprado a pequeños productores se refinan en un molino local. Esto incluye los costos de transporte interno y los costos de despacho de aduanas en el país de origen.',
                auctionBonus: 'Bono de subasta',
                auctionBonusExplanation: 'Del precio de compra de la subasta a ciegas, es la cantidad que supera el precio de inicio. Esta cantidad se pagará al productor como un bono de subasta.',
                shippingFee: 'Costos de flete',
                shippingFeeExplanation: 'Es el total del costo de transporte y el costo de importación (Tarifa de despacho de aduana, Tarifa de solicitud fitosanitaria, etc.).',
                importTax: 'Impuestos de importacion',
                importTaxExplanation: 'Es el {{ importTaxRate }} del total del costo de envío y del precio del producto.',
                typica: 'TYPICA',
                typicaExplanationForExclusiveLot: 'Compensación de TYPICA ({{exclusiveTypicaHandlingRate}})',
                typicaExplanationByBagCount: 'Es una recompensa de TYPICA. ({{ lessThan5Bags }} menos de 5 bolsas, {{ moreThan5Bags }} más de 5 bolsas, {{ moreThan10Bags }} más de 10 bolsas, {{ moreThan50Bags }} más de 50 bolsas)',
                typicaExplanationByWeight: 'Compensación de TYPICA (menos de 300 kg: {{ lessThan300Kg }}, 300 kg o más: {{ moreThan300Kg }}, 600 kg o más: {{ moreThan600Kg }}, 3,000 kg o más: {{ moreThan3000Kg }})',
                typicaExplanationForTypicaSelection: 'Compensación de TYPICA (40%)',
                typicaExplanationForTypicaSelectionByWeightV1: 'Compensación de TYPICA (menos de 300 kg: 40%, 300 kg o más: 35%, 600 kg o más: 30%, 3,000 kg o más: 25%)',
                typicaExplanationForTypicaSelectionByWeightV2: 'Compensación de TYPICA (menos de 300 kg: 35%, 300 kg o más: 25%, 600 kg o más: 20%, 3,000 kg o más: 15%)',
                consumptionTaxExplanation: '{{ taxRate }} de los costos y tarifas imponibles.',
                vatReverseChargeExplanation: 'Se ha aplicado el cargo invertido de IVA (0%).',
                oldPriceVersionKgPriceNotice: 'Precio unitario en kg excluyendo "Costo de Pago diferido (sin impuestos), Pago anticipado descuento" y "Tasas de servicio (exentos de impuestos)".',
                newPriceVersionKgPriceNotice: 'Precio unitario por kg, excluyendo los ‟descuentos o tarifas según el momento de pago”.',
                specialTypicaDiscount: 'Discount',
                specialTypicaDiscountExplanation: 'This is the total discount amount.',
                shippingFeeForJp: 'Costos de transporte internacional',
                shippingFeeExplanationForJp: 'El coste desde el puerto de carga hasta el puerto/aeropuerto de desembarque.',
                importTaxForJp: 'Costos de importación y transporte',
                importTaxExplanationForJp: 'Total de los gastos de transporte e importación (tarifa aduanera, tarifa de solicitud fitosanitaria, etc.) desde el puerto de desembarque hasta el almacén.',
                consumptionTaxExplanationForJp: 'El monto total está sujeto a impuestos del 8% para los granos de café verde y del 10% para los costos de transporte internacional y otros gastos.',
                CoffeeCherryExplanation: 'Remarks',
                negativeBreakdownCoffeeCherryExplanation: 'As the cost of cherries of in Ethiopia continues to rise, it becomes increasingly difficult for washing stations, mills and exporters to stay profitable. {{producerName}}, however, believes that building long-term partnerships with roasters is important in the overall sustainability of the industry and so, in valuing those relationships, will be offering their coffee at an average price of the last few years, rather than raising it significantly.',
            },
            paidStatus: 'Estado de pago',
            paidMessage: 'Pagado en {{paymentDate}}',
            unpaidMessage: 'Pague antes del {{expiredDate}}',
            changePaymentMethod: 'Changer le mode de paiement',
            vatrcHelp: 'Ingrese su número de IVA en la pantalla de su perfil para aplicar el cargo invertido de IVA.',
        },
        adminUsers: {
            title: 'Users',
        },
        adminRoasters: {
            title: 'Lista de tostadores',
            typicaShareRatioCalculatedAt: 'TYPICA share ratio calculated at',
        },
        adminRoasterDetail: {
            title: 'Details for {{roaster}}',
        },
        adminProducers: {
            title: 'Lista de productores',
        },
        adminProducerDetail: {
            title: 'Details for {{producer}}',
        },
        countryInformations: {
            title: 'Informacion sobre el pais de origen',
        },
        roasterCountries: {
            title: 'Paises en venta',
        },
        adminOrder: {
            title: 'Reserva de proxy',
            selectRoaster: 'Seleccione un tostador',
        },
        warehouses: {
            title: 'Gestion de almacenes',
        },
        warehouseItems: {
            title: 'Inventario de almacén',
            deliveryRequest: 'Solicitud de entrega',
            addressInfo: 'Dirección de Envío',
            selectItems: 'Seleccione el lot que desea solicitar la entrega',
            explainationForQuantity: 'La cantidad se muestra en unidades de paquete y es diferente de la unidad de pedido en el momento de la reserva',
            editDeliveryRequest: {
                caption: '¿Necesita modificar su agenda de entrega?',
                button: 'Modificar agenda de entrega',
            },
        },
        deliveryRequests: {
            title: 'Lista de solicitudes de entrega',
            import: 'Input delivery charges in a batch',
        },
        deliveryRequestDetail: {
            title: 'Detalles de la solicitud de envío',
            basicInfo: 'Información básica',
            editForm: 'Editar formulario',
        },
        newDeliveryRequest: {
            title: 'Add New Delivery Request',
        },
        roasterWarehouseItems: {
            requestable: 'Entrega disponible',
            delivered: 'Entregado',
            delivering: 'Entrega en progreso',
        },
        offerListForum: {
            translateMessage: 'Traducir el mensaje',
            changeTranslationLanguage: 'Cambiar idioma de traducción',
            languages: {
                en: 'Ingles',
                es: 'Español',
                ja: 'Japones',
                zh: 'Chino',
                ko: 'Coreano',
            },
        },
        monthlyClosing: {
            title: 'Lista de cierre mensual',
            createButton: 'Proceso de cierre mensual',
        },
        balanceSheetEntry: {
            title: 'Balance Sheet Entries',
            advanceReceived: 'Advance Received',
        },
        offices: {
            title: 'Oficina',
        },
        invoicePayment: {
            title: 'Pago de la factura "{{invoiceTitle}}"',
            suspendedMessage: "I'm very sorry\n\nWe regret to inform you that we are temporarily suspending credit card payments due to the migration of our payment system.\nPlease wait a while for the migration process. Please make your payment after the migration of the payment system is completed. Or if you are in a hurry, please make your payment by bank transfer.\n",
        },
        transportToWarehouse: {
            waterActivity: 'Actividad de agua interna',
            moistureContent: 'Porcentaje de humedad',
        },
        adminAuction: {
            title: 'Estado de subasta de {{offerListName}} / {{lotNumber}}',
            auctionClosed: 'Esta subasta ya ha finalizada',
            auctionOpened: 'Esta subasta se está llevando a cabo',
            closeAuction: 'Terminar la subasta',
            confirmation: 'This auction will be closed. Bids cannot be canceled after the auction is closed. Do you want to proceed?',
        },
        roasterBids: {
            title: 'Lista de oferta',
        },
        roasterAuction: {
            title: 'Resultados de la subasta de {{offerListName}} / {{lotNumber}}',
            bidQuantity: 'El número de ofertas exitosas',
            roasterAuctionResult: 'Resultado de la oferta exitosa suya',
            auctionResult: 'Resultado de las ofertas en general',
        },
        adminCreateTypicaStockItems: {
            title: 'Create TYPICA Selection',
        },
        adminTypicaStockItems: {
            title: 'TYPICA Selection',
            helpQuantity: 'The total number of typica stock. This value is reflected when creating contracts such as Shipping instructions.',
            helpRemainingQuantity: 'Quantity - Ordered Quantity + Adjustment Quantity',
            helpAdjustmentQuantity: 'For adjusting the number of items in typica stock (e.g., to reduce the number of items in stock for sample requests)',
            helpSampleRemainingQuantity: 'Sample total quantity - Sample ordered quantity',
        },
        adminNewTypicaStockOrder: {
            title: 'Proxy pre-order from TYPICA Selection',
        },
        adminTypicaStockOrders: {
            title: 'TYPICA Selection pre-orders',
        },
        adminTypicaStockSampleOrders: {
            title: 'TYPICA Selection sample requests',
        },
        adminSalesContractAndAuctionBonusInvoice: {
            title: 'Sales Contract / Auction Bonus Invoice',
        },
        adminSalesContractBankAccount: {
            title: 'Producer Bank account information for salesContract',
        },
        producerBankAccounts: {
            title: 'Lista de información de la cuenta bancaria',
            edit: 'Edición de información de cuenta bancaria',
            new: 'Creación de información de cuenta bancaria',
        },
        producerOkagesamaNoMori: {
            title: 'OKAGESAMA',
        },
        adminRoasterSalesReward: {
            title: 'Roaster Sales Reward',
            netWeight: 'Weight',
            quantity: 'Quantity',
        },
        typicaSelection: {
            title: 'Selección TIPICA',
            order: 'Ver los detalles de la reserva',
            sampleOrderPeriod: 'Always',
            orderPeriod: 'Always',
            paymentPeriod: 'Pago posterior a la entrega',
            estimatedDeliveryPeriod: 'Una semana después del pedido',
            sampleOrder: 'Click here to request a sample',
            orderFormStepper: {
                order: 'Pago y dirección de cobranza',
                deliveryRequest: 'Configuración de envío',
            },
            tooltip: {
                invalidDeliveryRequestGroup: {
                    oneTime: {
                        body1: 'La fecha de entrega está en blanco',
                        body2: 'Especifique una fecha de entrega',
                    },
                    installment: {
                        body1: 'Aún quedan lotes que se pueden enviar',
                        body2: 'Especifique todas las fechas de entrega por partes',
                    },
                },
                isNotWarehousing: {
                    body1: 'Aún no está disponible',
                    body2: 'No puede elegir una fecha de entrega para lotes que aún no hemos recibido',
                },
                inValidDeliveryRequestItemsAndRequestDate: 'Escriba el número de envíos o día de entrega',
            },
        },
        preOrderRequest: {
            title: 'Sus solicitudes de repetición de pedido',
            new: 'Crear nueva solicitud de repetición de pedido',
            requestedOffer: 'Requested for repeat order Lot',
            lotNumberBlank: 'Solicitar de la misma lista de ofertas',
        },
        roasterAddresses: {
            title: 'Libreta de direcciones',
            billingAddresses: 'Dirección de cobranza',
            deliveryAddresses: 'Dirección de envío',
        },
        cuppingComments: {
            title: 'Resumen de catas',
            commentedBy: 'Catado por',
            otherRoasters: 'Mostrar otros {{ count }} tostadores',
        },
        createCuppingComment: {
            title: 'Escribir comentario',
        },
        deliveryRequestItemsAndRequestDateForm: {
            title: 'Configuración de envío',
            subheaders: {
                oneTime: 'Entregaremos todo junto en el tiempo de entrega estimado.',
                installment: 'Dividiremos la entrega hasta en 3 veces desde el tiempo de entrega estimado.',
                installmentCaption: 'Entrega estimada: Aprox. 1 semana desde la reserva',
            },
            type: {
                oneTime: 'Entrega en una vez',
                installment: 'Entrega en partes',
            },
            changeTimings: 'Cambiar a {{ timing }}',
            buttons: {
                new: 'Establecer el tiempo de entrega',
                add: 'Agregar tiempo de entrega',
            },
            captions: {
                datePicker: {
                    fastestDelivery: '* Si se deja en blanco, la entrega se realizará en el plazo más breve posible.',
                    main: {
                        deliveryDateExplanation: '* Puede especificar un período menor a 5 meses desde la fecha de solicitud de envío después de {{ startWeek }} a partir de hoy.',
                        startWeek1: '1 semana',
                        startWeek2: '2 semanas',
                    },
                    sub: {
                        europe: '* Tenga en cuenta que la entrega puede demorar unas 2 semanas más según la región, por lo que le recomendamos especificar la fecha de entrega lo más rápido posible.',
                        etc: '* Tenga en cuenta que la entrega puede demorar 1 semana más según la región, por lo que le recomendamos especificar la fecha de entrega lo más rápido posible.',
                    },
                },
                card: '* Recomendamos el envío agrupado para garantizar la frescura, pero puede elegir la entrega por partes según su conveniencia.',
            },
            dialog: {
                title: 'Tiempo de entrega',
            },
        },
        adminWarehouseHoliday: {
            title: 'Warehouse holidays',
        },
    },
    labels: {
        stock: 'Disponible',
        stockUnit: 'Sacos',
        lotRef: 'LOT',
        offerListSummary: 'Resumen de ofertas',
        farmWithLink: 'Fincas',
        curatorName: 'Nombre del curador',
        seller: 'Vendedor',
        material: 'Material',
        story: 'Narrativo',
        period: 'Período de oferta',
        activeOfferLists: 'En Oferta',
        preparingOfferLists: 'Preparando oferta',
        expiredOfferLists: 'Expirado',
        noData: 'No se encontraron los datos',
        paymentTimingOnAdmin: 'Tiempo de pago',
        fullAddress: 'Dirección',
        deliveryItems: 'Lista de envío (Lot: cantidad)',
        all: 'Todos',
        inStock: 'En stock',
        forum: 'Tablón de anuncios',
        forumDisplayName: 'Nombre para mostrar en el tablón de anuncios',
        taxed: 'Sujeto a impuestos',
        paymentTimingHandlingFee: {
            negativeValue: 'Descuentos',
            positiveValue: 'Tasa de financiación',
        },
        paid: 'Pagado',
        exported: 'Al exportar',
        imported: 'Al importar',
        uploadContract: 'Seleccione el contrato para cargar',
        uploadDocuments: 'Por favor seleccione el documento a subir',
        uploadBusinessNumberKrdocument: 'Seleccione un archivo de imagen',
        selectFoundingCurator: 'Input Founding curator name',
        pending: 'Por definir',
        newRoasterCampaignDiscount: 'Descuento por primera compra',
        couponTarget: 'Aplicando el cupón',
        newRoasterCampaignUnderway: 'Promo for first-time users!',
        agree: 'De acuerdo',
        memo: 'Notas',
        tradeCountryUsages: 'uso deseado',
        tradeCountryProcessings: 'Método de procesamiento',
        tradeCountryPriceRanges: 'Gama de precios',
        uneditableJoinedInOkagesamaNoMori: 'Cannot edit joined in OKAGESAMA with active offer lists',
        contributedToOkagesamaNoMori: '* Ya ha participado en OKAGESAMA',
        default: 'Por defecto',
        billingAddress: 'Dirección de cobranza',
        deliveryAddress: 'Dirección de envío',
        deliveryRequestFormRequestDate: 'Fecha de entrega',
        fastestDeliveryRequest: 'Entrega rápida',
        deliveryRequestByDate: 'Entrega por fecha',
        includesItems: 'Include invoice items',
        bulkDownloadMode: 'Bulk download mode',
        miscFeeForJp: 'Otras tarifas *2',
        taxNodeForJpCalculation: '*1 está sujeto a un impuesto del 8 % / *2 está sujeto a un impuesto del 10 % / *3 no está sujeto a impuestos',
    },
    buttons: {
        yes: 'Si',
        no: 'No',
        create: 'Crear',
        update: 'Actualizar comentario',
        delete: 'Borrar',
        cancel: 'Cancel',
        apply: 'Apply',
        complete: 'Enviar',
        resetPassword: 'Restablecer la contraseña',
        changePassword: 'Cambiar la contraseña',
        reconfirmEmail: 'Reenviar email de confirmación',
        chooseFile: 'Seleccione un archivo',
        upload: 'Subir',
        calculateFixed: 'Determinar el precio final',
        cancelFixed: 'Cancelar confirmación de precio final',
        pay: 'Realizar pago confirmado',
        unpay: 'Cancelar pago confirmado',
        downloadInvoice: 'Descarga de facturas',
        salesContractDownloadPdf: 'Descargar Sales Contract',
        auctionBonusInvoiceDownloadPdf: 'Descargar Auction Bonus Invoice',
        downloadCsv: 'Descarga CSV',
        deliveryRequest: 'Solicitar entrega',
        processing: 'Procesando...',
        import: 'Importación',
        addItem: 'Add Item',
        createContracts: 'Creación de contrato',
        changeStatusTo: 'Establecer en {{status}}',
        setBankAccount: 'Establecer la información de la cuenta bancaria',
        bankAccount: 'información de cuenta bancaria',
        selectFoundingCurator: 'Select Founding curator',
        changeFoundingCurator: 'Change Founding curator',
        deleteFoundingCurator: 'Cancel Founding curator',
        salesReward: 'Sales Reward',
        manageCommunityManager: 'Manage Community Manager',
        stripePayment: 'Pagar',
        taiwanApiResponse: {
            resend: 'Resend(Government Uniform Invoices)',
            update: 'Set success without resend(Government Uniform Invoices)',
            destroy: 'Remove success(Government Uniform Invoices)',
        },
        priceDetail: 'Ver los detalles de la reserva',
        setAsDefault: 'Establecer por defecto',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
        next: 'Siguiente',
        updateNow: 'Update now',
        downloadOffersCsv: 'Download all lots',
    },
    links: {
        login: 'Login por aqui',
        register: 'El nuevo registro está aquí',
        resetPassword: 'Si olvida su contraseña, haga clic aquí',
        reconfirmEmail: 'Reenviar correo electrónico de confirmación aquí',
        back: 'Regreso',
        payFromHere: 'Pago aquí',
        story: 'Narrativo',
        movie: 'Pelicula',
        privacy_policy: 'Politica de privacidad',
        specified_commercial_transactions_law: 'Acerca de la visualización basada en la Ley de transacciones comerciales especificada',
        tos: 'Términos de servicio',
        trackingUrl: 'Estado del transporte',
        cookiePolicy: 'Política de cookies',
    },
    messages: {
        registerSuccess: 'Hemos enviado un correo electrónico a {{email}} para confirmar la validez de su dirección de correo electrónico. Complete el registro desde el enlace proporcionado en el correo electrónico.',
        confirmationSuccess: 'Confirmada la verificación de su dirección de email. Inicie sesión con la dirección de email y la contraseña configuradas.',
        unlockSuccess: 'Su cuenta ha sido desbloqueada.',
        resetPasswordSuccess: 'Se aceptó el restablecimiento de la contraseña. Nos comunicaremos con usted por correo electrónico',
        accountUpdateSuccess: 'Se ha editado la información de la cuenta. Nos comunicaremos con usted por correo electrónico, verifique.',
        changePasswordSuccess: 'Contraseña reestablecida.',
        reconfirmEmailSuccess: 'Se ha reenviado el correo electrónico de confirmación. Nos comunicaremos con usted por correo electrónico, verifique.',
        invalidEmail: 'Ingrese el Email correcto',
        invalidPostalCode: 'Ingrese el código postal solo en números',
        loginSuccess: 'Ingreso exitoso',
        logoutSuccess: 'Desconectado',
        uploadSuccess: 'La carga de CSV cambió',
        createSuccess: 'Creado',
        updateSuccess: 'Ha sido actualizado',
        deleteSuccess: 'Eliminado',
        updateFailure: 'Error',
        deleteConfirm: 'Borrar. ¿Estas realmente seguro?',
        rejectConfirm: 'This will cancel the bid for failing the screening. Are you really sure?',
        bidCancelConfirm: 'Cancelar la puja. ¿Está seguro?',
        orderSuccess: 'Se realizo el pedido',
        typicaStockOrderSuccess: 'Su pedido ha sido realizado. Puede solicitar la entrega de artículos que ya están disponibles en la lista de inventario del almacén.',
        sampleOrderSuccess: 'Se realizo la reserva de muestra',
        deliveryRequestSuccess: 'Solicitamos la entrega. Nos comunicaremos con usted tan pronto como estemos listos para enviar',
        cancelConfirm: 'La cancelación es irrevocable. ¿Estas realmente seguro?',
        calculateFixed: "Aprobar la solicitud de reserva del tostador y concluir el contrato de venta.\nAseg\u00FArate de que la cantidad sea correcta.\n\u00BFSeguro que quiere confirmar el precio final?",
        calculateFixedSuccess: 'Se ha confirmado el precio final de la reserva objetivo.',
        cancelFixed: "Cancelar el contrato de compraventa con el tostador establecido.\nExiste el riesgo al cancelar un contrato.\n\u00BFDe verdad quieres cancelar?",
        cancelFixedSuccess: 'Confirmación de precio final cancelada.',
        commentSuccess: 'Comentado',
        deleteCommentConfirmTitle: 'Eliminar comentario',
        deleteCommentConfirmBody: 'Esta seguro de eliminar comentario?',
        changePasswordTokenError: 'El restablecimiento de contraseña ha expirado. Reinicie de nuevo',
        deleteInvoiceConfirmTitle: 'Eliminar factura',
        deleteInvoiceConfirmBody: 'Eliminar la factura. ¿Estas realmente seguro?',
        deleteInvoiceItemConfirmTitle: 'Eliminar extracto de facturación',
        deleteInvoiceItemConfirmBody: 'Eliminar la línea de facturación. ¿Esta realmente seguro?',
        sendInvoiceMailConfirmTitle: 'Notificación de email',
        sendInvoiceMailConfirmBody: 'Envíe un correo electrónico al tostador para informarle que se ha emitido la factura. ¿Esta realmente seguro?',
        sentSuccess: 'Se envio el Email',
        payConfirmTitle: 'Realizar pago confirmado',
        payConfirmBody: 'Asegúrese de que el pago haya sido confirmado. ¿Esta realmente seguro?',
        unpayConfirmTitle: 'Cancelar pago confirmado',
        unpayConfirmBody: 'Cancelar la confirmación del pago. ¿Esta realmente seguro?',
        nRowsSelected: '{0}está siendo seleccionado',
        noDeliveryRequest: 'Sin solicitud de entrega',
        invalidOrderCombination: 'Las solicitudes de muestra y las reservas no se pueden realizar al mismo tiempo.',
        orderExplanationTitle: 'Notas sobre las reservas',
        sampleOrderExplanationTitle: 'Precauciones con respecto a la solicitud de muestras',
        auctionOrderExplanationTitle: 'Precauciones con respecto a las reservas de subastas',
        sampleOrderExplanationBody: "Dado que el n\u00FAmero es limitado, las solicitudes de muestra est\u00E1n limitadas a aquellos que desean comprar.\nTambi\u00E9n realizamos catas comunitarias donde puede probar todos los lotes en todo el pa\u00EDs.\nPara obtener m\u00E1s informaci\u00F3n, consulte la informaci\u00F3n por correo electr\u00F3nico.",
        deliveryTimeExplanationTitle: 'Precauciones con respecto a la entrega',
        deliveryTimeExplanationForUsBody: "* There are additional costs associated with last-mile delivery from RPM warehouse in NJ via Accurate Transport.\n    * Please click <0>here</0> for delivery charges and <1>here</1> for delivery time.\n    * Arranging your own local shipping company or picking up at the warehouse are also possible. If so, please indicate this in the Note.\n    * Delivery could be delayed by logistical problems.\n    * Please feel free to ask if you have any questions.",
        deliveryTimeExplanationBody: "* Los gastos de env\u00EDo nacionales se cobrar\u00E1n por separado.\n* Puede retrasarse de la fecha de entrega prevista por circunstancias del canal de distribuci\u00F3n.\n* Si tiene alguna pregunta, no dude en contactarnos.\n* Se cobrar\u00E1 una tarifa por separado por la entrega desde el almac\u00E9n holand\u00E9s.\n* Nuestra empresa de entrega afiliada, CTS Group, se encarga incluso de su tostador.\n* Consulte <0>este archivo</0> para conocer los gastos de env\u00EDo.\n* Las bolsas con un peso igual o superior a 23 kg se entregan siempre sobre palet de acuerdo con la normativa de la UE.\n* Dado que no se colocan otros art\u00EDculos en el caf\u00E9 comprado (no apilable), la tarifa de env\u00EDo ser\u00E1 de la paleta de 3/4 euros.",
        orderExplanationForUsBody: "* Please refer to <0>our terms and conditions</0> before proceeding with pre-orders.\n\n    * Pre-order pricing is ex-warehouse.\n    There are additional costs associated with last-mile delivery from RPM warehouse in NJ via Accurate Transport.\n    Please see <1>this file</1> for delivery costs by destination in NYC area.\n    Kindly note that shipping fees for delivery outside of New York, New Jersey, Maryland, Delaware, and Washington D.C. will be confirmed once we obtain a quote from the delivery company.\n\n    * An estimated delivery date may be delayed due to circumstances in production areas or distribution channels.\n\n    * The quality of the product shall be the same as the sample.\n\n    * As green coffee production is strongly affected by the situation and climate of production areas, conditions may be subject to change. Please note that this pre-order does not immediately guarantee the conclusion of your order. We will send you confirmation of your order after the end of a pre-order period.",
        orderExplanationBody: "* Aseg\u00FArese de revisar los <0> T\u00E9rminos de servicio </0> antes de hacer una reserva.\n\n* Se agregar\u00E1n tarifas adicionales para la entrega desde nuestro almac\u00E9n en los Pa\u00EDses Bajos. Consulte <1>este archivo</1> para ver los costos de entrega.\n\n* Dependiendo de la zona de producci\u00F3n y condiciones de transporte, se puede retrasar la entrega estimada.\n\n* La calidad del producto se basar\u00E1 en la muestra.\n\n* La producci\u00F3n de granos de caf\u00E9 verde se ve fuertemente afectada dependiendo de las condiciones del \u00E1rea de producci\u00F3n y el clima, por lo que las condiciones pueden cambiar. Esta reserva no garantiza que la reserva se completar\u00E1. Le informaremos sobre el establecimiento de la reserva una vez que finalice el per\u00EDodo de reserva.",
        createdInvoices: 'Se han creado {{count}} facturas',
        orderNotStarted: 'La reserva comienza desde {{ startedAt }}',
        createContractsTitle: 'Preparation of contract documents',
        createContractsBody: "This will create the templates for the contract documents.\nPlease make sure that you have not forgotten to create TYPICA Stock.\nDo you want to proceed?",
        changeContractStatusToPublished: 'Set to Published. If you make it issued, it will be published to the producer and you will be notified by email. Are you sure?',
        changeContractStatusToDraft: 'Set to draft. Are you sure?',
        salesContractDownloadExplanationTitle: 'Para descargar Sales Contract',
        salesContractDownloadExplanationBody: "Antes de descargar el Sales Contract,\ndebe configurar la informaci\u00F3n de su cuenta bancaria Seleccione la informaci\u00F3n de su cuenta bancaria e incluya cualquier nota adicional.",
        addBankAccountInformation: "Para descargar el Sales Contract, debe registrar la informaci\u00F3n de su cuenta bancaria.\nPor favor, registre la informaci\u00F3n de su cuenta bancaria desde el siguiente enlace.",
        createBankAccount: 'Información de la cuenta bancaria creada',
        orderedOfferNotExist: 'No se encontró el pedido anticipado',
        stripeConfirmBody: '¿Está listo para confirmar el pago?',
        updateSuccessInvoicePaid: 'El pago se ha completado. Tenga en cuenta que el pago puede tardar en reflejarse en la factura.',
        deliverySampleWarningMessage: 'Las muestras se enviarán en cuanto lleguen a un almacén. Deben llegar a un almacén el {{ approvalDate }}.',
        deliverySampleWarningConfirmationMessage: 'Las muestras siguientes se enviarán después de que lleguen a un almacén.',
        contactToTypicaMessage: 'Contáctenos mediante el siguiente correo electrónico:',
        contactToTypicaMailSubject: 'TYPICA Direct Trade Platform',
        selectColumns: 'Select Columns',
        exchangeRateMoreThanHighestRateOnPrevMonth: 'The exchange rate exceeds the highest rate ({{ rate }}) for the previous month. Are you sure?',
        exchangeRateLessThanLowestRateOnPrevMonth: 'The exchange rate is below the lowest rate ({{ rate }}) of the previous month. Are you sure?',
        updateRequired: 'New version {{ version }} found! Reload after 5 seconds...',
        newPlatformRegisterNotice: 'Hemos migrado a la nueva plataforma a partir del 6 de agosto de 2024. Si desea registrarse como nuevo usuario, regístrese desde <0>Haga clic aquí</0>.',
        newPlatformNotice: 'Migraremos a una <0>nueva plataforma</0> a partir del 6 de agosto de 2024.',
        newPlatformSampleNotice: 'La lista de solicitud de muestras de la nueva plataforma está <0>aquí</0>.',
        newPlatformOrderNotice: 'La lista de reservas de la nueva plataforma está <0>aquí</0>.',
        newPlatformInvoiceNotice: 'La factura de la nueva plataforma está <0>aquí<0/>.',
        newPlatformProfileNotice: "La informaci\u00F3n actualizada aqu\u00ED no se transfiere a la nueva plataforma,\nas\u00ED que culquier actualizaci\u00F3n hazla directamente en la <0>nueva plataforma</0>.",
    },
    errors: {
        isRequired: 'Ingrese {{ field }}',
        invalid: '{{ field }} es un valor no válido',
        positive: 'Ingrese 1 o más para {{ field }} ',
        integer: 'Ingrese números para {{ field }}',
        decimal: 'Ingrese {{ field }} con números y.(Punto decimal)',
        alphanumeric: 'Ingrese {{ field }} en caracteres alfanuméricos',
        invalidPostalCode: 'Postal code must be alphanumeric 7 characters',
        invalidCity: 'City must be 12 double-byte characters or less',
        invalidAddress: '{{ field }} must be full-width {{ fullWidthMaxLength }} character/half-width {{ halfWidthMaxLength }} character or less',
        purchaseLimitError: 'El límite de compra para este lot es {{limit}}',
        lowestBidFobPriceError: 'El precio ingresado está por debajo del precio inicial',
        totalFeeUpperLimitError: 'Ha superado el límite de pago de su tarjeta de crédito. Cambie a transferencia bancaria o ajuste el monto total a 8 dígitos o menos',
        noStock: 'Falta de stock',
        sameTypicaStockItemExists: 'Same Lot and warehouse combination already exists',
        mustOverOfferMinOrderWeight: 'El peso debe ser {{ minOrder }} o mayor',
        notSelectableLessThanOrdersTotalWeight120Kg: 'Available for pre-orders of 120 kg or above',
    },
    options: {
        isExists: {
            '1': 'Hay',
            '0': 'No hay',
        },
        isQGrader: {
            '1': 'Posee la certificación Q Grader',
            '0': 'No posee la certificación Q Grader',
        },
    },
    stripePayment: {
        failure: 'Pago fallido. Por favor, inténtelo de nuevo desde el principio.',
        afterStatusSucceeded: 'El pago ha sido efectuado. Tenga en cuenta que puede tardar un tiempo hasta que aparezca como pagado.',
    },
    tradeCountryUsages: {
        filter: 'Filter',
        espresso: 'Espresso',
        omniroast: 'Omniroast',
        blend_component: 'Blend component',
    },
    tradeCountryProcessings: {
        washed: 'Washed',
        honey: 'Honey',
        natural: 'Natural',
        washed_anaerobic: 'Washed Anaerobic',
        natural_anaerobic: 'Natural Anaerobic',
        experimental: 'Experimental',
    },
    tradeCountryPriceRanges: {
        '5_to_10_dollars': '$5~10',
        '10_to_15_dollars': '$10~15',
        '15_to_20_dollars': '$15~20',
        '20_to_30_dollars': '$20~30',
        '30_dollars_or_more': '$30~',
    },
};
